export const getFormattedPrice = (
  productPrice: number | null | undefined,
  negative = false
): string => {
  if (typeof productPrice !== "number") {
    return `€0,-`;
  }

  return productPrice % 1 === 0
    ? productPrice
        .toLocaleString("nl-NL", { style: "currency", currency: "EUR" })
        .replace(",00", ",-")
        .replace(/\s/g, "")
    : productPrice
        .toLocaleString("nl-NL", { style: "currency", currency: "EUR" })
        .replace(/\s/g, "");
};
